import {object, string} from 'yup';
import {passwordRegex, passwordPhrase} from '../../../constants';
import {regexTwoMinCharacters} from '../../../constants';

export const AdminProfileValidator = object().shape({
  email: string()
    .email('Please enter a valid email address')
    .required('Fill in your email'),
  firstName: string()
    .required('Fill in your first name')
    .trim()
    .matches(
      regexTwoMinCharacters,
      'Only alphabets are allowed (at least 2 characters long)',
    ),
  lastName: string()
    .required('Fill in your last name (surname)')
    .trim()
    .matches(
      regexTwoMinCharacters,
      'Only alphabets are allowed (at least 2 characters long)',
    ),
  password: string()
    .matches(passwordRegex, passwordPhrase)
    .required('Fill in your password'),
});
